import { Component } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-smart-restaurant-suite',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './smart-restaurant-suite.component.html',
  styleUrl: './smart-restaurant-suite.component.css',
})
export class SmartRestaurantSuiteComponent {
  constructor(title: Title, meta: Meta) {
    title.setTitle('Smart Restaurant Suite');
    meta.addTags([
      {
        name: 'description',
        content: 'Discover the best way to operate your restaurant',
      },
      {
        name: 'keywords',
        content:
          'Pixel Pro, Restaurant System, POS, Customer Ordering, Website, Restaurant Analytics',
      },
    ]);
  }

  scrollToElement($element: any, offset: number = 0): void {
    window.scrollTo({
      behavior: 'smooth',
      top:
        $element.getBoundingClientRect().top -
        document.body.getBoundingClientRect().top -
        offset,
    });
  }
}
